export default {
	about: {
		title: false
	},
	main: {
		tagline: true,
		background: { width: 1920, height: 710 }
	},
	services: {
		title: true
	},
	accolades: {
		title: true
	},
	widgets: {
		title: true
	},
	testimonials: {
		title: false,
		navButtonColor: '#000000'
	},
	contact: {
		title: true
	}
};
